import debounce from 'lodash.debounce';
import React, { useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/shared/buttons/Button';
import ContainerHeader from '../../components/shared/container/ContainerHeader';
import Search from '../../components/shared/search/Search';
import { getBrandsActions, setBrandsSearchAction } from '../../redux/actions/brandsActions';
import CreateBrandModal from './modals/CreateBrandModal';

const BrandsHeader = ({ readOnly }) => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.brands?.search);
  const [showCreateBrandModal, setShowCreateBrandModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const debounced = debounce((args) => {
    dispatch(setBrandsSearchAction(args));
  }, 500);

  const handleSearchChange = (newSearchValue) => {
    debounced(newSearchValue);
  };

  const handleBrandModalSubmit = async () => {
    setShowCreateBrandModal(false);
    setLoading(true);
    await dispatch(getBrandsActions(search));
    setLoading(false);
  };

  return (
    <ContainerHeader>
      {showCreateBrandModal && (
        <CreateBrandModal
          onModalSubmit={() => handleBrandModalSubmit()}
          onModalClose={() => setShowCreateBrandModal(false)}
        />
      )}
      <Search value={search.search} onChangeAction={handleSearchChange} />
      {!readOnly && (
        <Button variant={'primary'} disabled={loading} onClick={() => setShowCreateBrandModal(true)}>
          <AiOutlinePlus />
          Додати
        </Button>
      )}
    </ContainerHeader>
  );
};

export default BrandsHeader;
